import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import { BiMinusCircle } from "react-icons/bi";
//date picker
import { useMutation } from "@apollo/client";
//src
import "../../Style/dialogstyle.scss";
import ListPurchase from "./ListPurchase";
import { AuthContext } from "../../Context/AuthContext";
import { CREATE_PURCHASE } from "../../Schema/Reqpurchase";

export default function CreatePurchase({
  open,
  handleClose,
  editData,
  setRefetch,
  dialogTitle,
}) {
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [requireField, setRequireField] = useState(false);
  const calculateSubTotal = () => {
    let subTotal = 0;
    listData.forEach((item) => {
      subTotal +=
        (parseFloat(item.unitPrice) || 0) * (parseFloat(item.qty) || 0);
    });
    return subTotal.toFixed(2);
  };

  const listReqPurchMaterial = {
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "" },
    checkUnitPrice: 0,
    unitPrice: 0,
    qty: 0,
    checkQty: 0,
    image: "",
    key: Date.now() + Math.random(),
    // unitPricePerItem: 0
  };

  const [listData, setListData] = useState([listReqPurchMaterial]);

  //startPurchase
  const [startPurchase] = useMutation(CREATE_PURCHASE, {
    onCompleted: ({ startPurchase }) => {
      // console.log("startPurchase::", startPurchase)
      setLoading(false);
      if (startPurchase?.status) {
        setAlert(true, "success", startPurchase?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", startPurchase?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
      // console.log("error::", error)
    },
  });
  //formik
  const CheckValidation = Yup.object().shape({
    // status: Yup.string().required("required!"),
    remark: Yup.string(),
    shippingFee: Yup.number().min(0),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      remark: "",
      shippingFee: 0,
      remark: "",
    },
    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      let createStatus = false;
      const BreakException = {};
      try {
        if (listData?.length !== 0) {
          listData?.forEach(function (elem) {
            // console.log("element: ", elem)
            if (
              elem?.materialId?.id !== undefined &&
              elem?.materialId?.id !== "" &&
              elem?.listMaterialUnitId?.id !== undefined &&
              elem?.listMaterialUnitId?.id !== "" &&
              elem?.unitPrice > 0 &&
              elem?.qty > 0
            ) {
              createStatus = true;
            } else {
              setLoading(false);
              setRequireField(true);
              createStatus = false;
              throw BreakException;
            }
          });
        } else {
          setLoading(false);
          setRequireField(true);
        }
      } catch (e) {
        if (e !== BreakException) throw e;
      }

      if (createStatus) {
        let listReqPurchMaterialToSubmit = listData.map((d) => {
          return {
            listMaterialUnitId: d?.listMaterialUnitId?.id,
            unitPrice: d?.unitPrice,
            qty: d?.qty,
            key: d?.key,
          };
        });

        setLoading(true);
        startPurchase({
          variables: {
            id: editData?._id,
            remark: values?.remark,
            purchaseMaterials: listReqPurchMaterialToSubmit,
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
  } = formik;

  const total =
    parseFloat(calculateSubTotal()) + parseFloat(values?.shippingFee);

  // console.log("editData::", editData,)
  useEffect(() => {
    if (editData) {
      setFieldValue("remark", editData?.remark ?? "");
      setFieldValue("shippingFee", editData?.shippingFee);
      setFieldValue("remark", editData?.remark ?? "");
    }

    if (editData?.checkMaterials?.length !== 0) {
      const dataFromBackend = editData?.checkMaterials?.map((d) => {
        // console.log("ddddd",d?.);
        return {
          key: Date.now() + Math.random(),
          materialId: {
            id: d?.listMaterialUnitId?.materialId?._id,
            title: d?.listMaterialUnitId?.materialId?.materialEnName,
          },
          listMaterialUnitId: {
            id: d?.listMaterialUnitId?._id,
            title: d?.listMaterialUnitId?.unitId?.unitKhName,
            imageSrc: d?.listMaterialUnitId?.imageSrc,
          },
          qty: d?.qty,
          unitPrice: d?.unitPrice,
        };
      });
      // console.log("dataFromBackend::", dataFromBackend)
      setListData([...dataFromBackend]);
    }
  }, [open, editData]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px" }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">បង្កើតការបញ្ជាទិញ</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12}>
                <Typography className="dialog-title-view">សម្ភារៈ</Typography>
              </Grid>
              <Grid item xs={12}>
                {editData?.voidBy !== null ? (
                  <ListPurchase
                    listData={listData}
                    setListData={setListData}
                    requireField={requireField}
                    dialogTitle={dialogTitle}
                    disabled
                    readOnly={true}
                  />
                ) : (
                  <ListPurchase
                    listData={listData}
                    setListData={setListData}
                    requireField={requireField}
                    dialogTitle={dialogTitle}
                    readOnly={true}
                  />
                )}
              </Grid>
              <Grid item xs={8}></Grid>
              <Grid item xs={4}>
                <Stack direction="column" spacing={1}>
                  <Stack direction="row" width="100%">
                    <Stack width={"32%"}>
                      <Typography className="total-title">តម្លៃ</Typography>
                    </Stack>
                    <Stack width={"18%"}>
                      <Typography className="total-title">:</Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      width={"50%"}
                      justifyContent={"space-between"}
                      className="total-boz"
                    >
                      <Typography className="total-boz-letter">$</Typography>
                      <Typography className="total-boz-letter">
                        {calculateSubTotal()}
                      </Typography>
                    </Stack>
                  </Stack>

                  <Stack direction="row" width={"100%"}>
                    <Stack justifyContent="center" width={"32%"}>
                      <Typography className="total-title">
                        ថ្លៃដឹកជញ្ជូន
                      </Typography>
                    </Stack>
                    <Stack justifyContent="center" width={"18%"}>
                      <Typography>:</Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      width={"50%"}
                      justifyContent={"space-between"}
                      className="total-boz"
                    >
                      <TextField
                        inputProps={{ min: 0 }}
                        className="text-field-right"
                        fullWidth
                        disabled
                        type="number"
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .css-1ua80n0-MuiInputBase-input-MuiOutlinedInput-input":
                            { textAlign: "right" },
                        }}
                        {...getFieldProps("shippingFee")}
                        error={Boolean(
                          touched.shippingFee && errors.shippingFee
                        )}
                        helperText={touched.shippingFee && errors.shippingFee}
                      />
                    </Stack>
                  </Stack>

                  <Stack direction="row" width={"100%"}>
                    <Stack justifyContent="center" width={"32%"}>
                      <Typography className="total-title">តម្លៃសរុប</Typography>
                    </Stack>
                    <Stack justifyContent="center" width={"18%"}>
                      <Typography className="total-title">:</Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      width={"50%"}
                      justifyContent={`space-between`}
                      className="total-boz"
                    >
                      <Typography className="total-boz-letter">$</Typography>
                      <Typography className="total-boz-letter">
                        {total ? total.toFixed(2) : "0.00"}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Grid>
              {/* <Grid item xs={12}>
                                <Typography className='field-title'>មតិយោបល់</Typography>
                                <TextField
                                    className='text-field'
                                    fullWidth
                                    multiline
                                    size='small'
                                    placeholder='remark'
                                    {...getFieldProps("remark")} />
                            </Grid> */}
              <Grid item xs={12}>
                <Typography className="field-title">ចំណាំ</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                />
              </Grid>
              {editData?.voidBy === null ? (
                <Grid item xs={12}>
                  {loading ? (
                    <Button className="btn-create" fullWidth>
                      កំពុងដំណើរការ...
                    </Button>
                  ) : (
                    <Button
                      className="btn-create"
                      fullWidth
                      onClick={handleSubmit}
                    >
                      បញ្ជាទិញ
                    </Button>
                  )}
                </Grid>
              ) : null}
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
